var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "TwoDimensionalCode.Scan",
    "options": {
        "objc_class_prefix": "TwoDimensionalCodeScan",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "randomCode",
                    "id": 1
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/component/qrcode-login/codescan.pb.js